import { tv } from 'tailwind-variants'

export const tagVariants = tv({
  base: ['flex items-center', 'gap-1', 'text-white font-bold', 'shadow-white-top-accent-inset'],
  variants: {
    size: {
      sm: 'px-1 py-[2px] rounded text-xs',
      md: 'p-1 rounded-lg text-base'
    },
    accentColor: {
      none: '',
      yellow: 'bg-dark-yellow',
      green: 'bg-dark-green',
      blue: 'bg-blue',
      pink: 'bg-pink-flamingo'
    }
  },
  defaultVariants: {
    size: 'md',
    accentColor: 'none'
  }
})
